export enum DialogEventEditor {
  Status = 'status',
  Location = 'location',
  Result = 'result',
}
